import React, { createContext, useState, useContext } from 'react'

const EventContext = createContext()

const EventProvider = ({children}) => {
    const [selEvent, setSelEvent] = useState("my EVENT")
    const [pageElementCount, setPageElementCount] = useState("all")

    const updateValue = () => {
        console.log("TEST")
    }
    
    return (

        <EventContext.Provider
            value={{
                selEvent,
                setSelEvent,
                updateValue,
                pageElementCount, 
                setPageElementCount
            }}>
        {children}

        </EventContext.Provider>
    )
}
const useEvent = () => {
    return useContext(EventContext)
};

export {EventProvider, useEvent} 